import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { baseurl } from "../../baseurl";

// ── Inline mock for preview – remove in production ──────────────────────────
const MOCK = {
  arrivalTime: "",
  bookingFee: "0",
  busType: "Electric A/C Seater (2+2)",
  cancellationPolicy: "0:3:100:0;3:4:100:0;4:12:50:0;12:24:25:0;24:72:15:0;72:168:15:0;168:-1:15:0",
  dateOfIssue: "2026-03-06T21:27:06+05:30",
  destinationCity: "Delhi",
  displayPnr: "52974",
  doj: "2026-03-07T00:00:00+05:30",
  dropLocation: "ISBT Kashmere Gate",
  dropLocationAddress: "ISBT Kashmere Gate, PLATFORM NO 49 to 51",
  dropLocationLandmark: "Isbt Kashmere Gate, Platform No. 49 To 51",
  dropLocationLatitude: "28.666823",
  dropLocationLongitude: "77.22933",
  dropTime: "810",
  firstBoardingPointTime: "540",
  inventoryItems: [
    { baseFare:"339.00", fare:"339.00", grandTotalFare:"355.95", serviceTax:"16.95", operatorServiceCharge:"0.00", seatName:"1", passenger:{ name:"Sadham", age:"46", gender:"MALE", mobile:"9932370928", title:"Mr", primary:"true" }, fareBreakup:{ customerPriceBreakUp:[ {componentName:"BASIC_FARE",value:"339.00",refundableValue:"339.0",cancellationHandling:"CANCELLATION_POLICY"}, {componentName:"SERVICE_TAX",value:"16.95",refundableValue:"16.95",cancellationHandling:"FULLY_REFUNDED"}, {componentName:"TOTAL_FARE",value:"355.95",refundableValue:"355.95",cancellationHandling:"CANCELLATION_POLICY"} ] } },
    { baseFare:"339.00", fare:"339.00", grandTotalFare:"355.95", serviceTax:"16.95", operatorServiceCharge:"0.00", seatName:"5", passenger:{ name:"Savita", age:"40", gender:"FEMALE", mobile:"9932370928", title:"Mrs", primary:"false" }, fareBreakup:{ customerPriceBreakUp:[ {componentName:"BASIC_FARE",value:"339.00",refundableValue:"339.0",cancellationHandling:"CANCELLATION_POLICY"}, {componentName:"SERVICE_TAX",value:"16.95",refundableValue:"16.95",cancellationHandling:"FULLY_REFUNDED"}, {componentName:"TOTAL_FARE",value:"355.95",refundableValue:"355.95",cancellationHandling:"CANCELLATION_POLICY"} ] } },
    { baseFare:"359.00", fare:"359.00", grandTotalFare:"376.95", serviceTax:"17.95", operatorServiceCharge:"0.00", seatName:"10", passenger:{ name:"Sahani", age:"18", gender:"MALE", mobile:"9932370928", title:"Mr", primary:"false" }, fareBreakup:{ customerPriceBreakUp:[ {componentName:"BASIC_FARE",value:"359.00",refundableValue:"359.0",cancellationHandling:"CANCELLATION_POLICY"}, {componentName:"SERVICE_TAX",value:"17.95",refundableValue:"17.95",cancellationHandling:"FULLY_REFUNDED"}, {componentName:"TOTAL_FARE",value:"376.95",refundableValue:"376.95",cancellationHandling:"CANCELLATION_POLICY"} ] } },
    { baseFare:"359.00", fare:"359.00", grandTotalFare:"376.95", serviceTax:"17.95", operatorServiceCharge:"0.00", seatName:"6", passenger:{ name:"Maya", age:"66", gender:"FEMALE", mobile:"9932370928", title:"Mrs", primary:"false" }, fareBreakup:{ customerPriceBreakUp:[ {componentName:"BASIC_FARE",value:"359.00",refundableValue:"359.0",cancellationHandling:"CANCELLATION_POLICY"}, {componentName:"SERVICE_TAX",value:"17.95",refundableValue:"17.95",cancellationHandling:"FULLY_REFUNDED"}, {componentName:"TOTAL_FARE",value:"376.95",refundableValue:"376.95",cancellationHandling:"CANCELLATION_POLICY"} ] } },
  ],
  MTicketEnabled: "true",
  partialCancellationAllowed: "true",
  pickUpContactNo: "8826060313",
  pickUpLocationAddress: "Kashyap Ashram Haridwar",
  pickupLocation: "Kashyap ashram (Pickup Van/Bus)",
  pickupLocationLandmark: "Nh 58 Delhi Dehradun Highway",
  pickupLatitude: "29.935412",
  pickupLongitude: "78.146949",
  pickupTime: "540",
  pnr: "TS260306212241980421RCKX/52974/Dehradun-Delhi A",
  primeDepartureTime: "540",
  reschedulingPolicy: { reschedulingCharge: "-1", windowTime: "0" },
  serviceCharge: "0.00",
  serviceStartTime: "2026-03-07 09:00:00",
  sourceCity: "Haridwar",
  status: "BOOKED",
  tin: "4BSK9PA2",
  travels: "Ezy Go Bus (10)",
  tripCode: "10",
  vaccinatedBus: "false",
  vaccinatedStaff: "false",
  vendorPnr: "TS260306212241980421RCKX",
  amount: "1547.00",
  cancellationCalculationTimestamp: "2026-03-07 09:00:00",
};

// ── Helpers ──────────────────────────────────────────────────────────────────
const minsToTime = (mins) => {
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  const p = h >= 12 ? "PM" : "AM";
  return `${h % 12 || 12}:${String(m).padStart(2, "0")} ${p}`;
};

const fmt = (n) => parseFloat(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const parsePolicy = (s) =>
  s ? s.split(";").map((r) => { const [a, b, c] = r.split(":"); return { hMin: a, hMax: b, pct: c }; }) : [];

const formatDate = (d) => new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });

const formatDOJ = (d) => new Date(d).toLocaleDateString("en-IN", { weekday: "long", day: "2-digit", month: "long", year: "numeric" });

// ── Styles ───────────────────────────────────────────────────────────────────
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=DM+Sans:wght@300;400;500;600&family=DM+Mono:wght@400;500&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  :root {
    --ink: #0f1923;
    --ink2: #3d4f5c;
    --ink3: #7a8fa0;
    --paper: #f8f6f1;
    --white: #ffffff;
    --accent: #1a4a6b;
    --accent2: #c8973a;
    --green: #1a6b4a;
    --red: #8b1a1a;
    --border: #ddd8ce;
    --shadow: 0 8px 40px rgba(15,25,35,0.12);
  }

  body { background: #e8e4dd; font-family: 'DM Sans', sans-serif; color: var(--ink); }

  .inv-page {
    min-height: 100vh;
    padding: 32px 16px 48px;
    background: #e8e4dd;
    background-image: 
      repeating-linear-gradient(0deg, transparent, transparent 40px, rgba(0,0,0,0.015) 40px, rgba(0,0,0,0.015) 41px),
      repeating-linear-gradient(90deg, transparent, transparent 40px, rgba(0,0,0,0.015) 40px, rgba(0,0,0,0.015) 41px);
  }

  .top-bar {
    max-width: 860px;
    margin: 0 auto 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
  }

  .btn { display: inline-flex; align-items: center; gap: 6px; border: none; cursor: pointer; font-family: 'DM Sans', sans-serif; font-weight: 500; border-radius: 6px; transition: all .2s; font-size: 13px; }
  .btn-ghost { background: rgba(255,255,255,0.7); color: var(--ink); padding: 8px 14px; border: 1px solid var(--border); }
  .btn-ghost:hover { background: white; }
  .btn-danger { background: #fff0f0; color: var(--red); padding: 8px 16px; border: 1px solid #f5c6c6; }
  .btn-danger:hover { background: #ffe0e0; }
  .btn-primary { background: var(--accent); color: white; padding: 8px 20px; }
  .btn-primary:hover { background: #153d5a; }

  .invoice {
    max-width: 860px;
    margin: 0 auto;
    background: var(--white);
    border-radius: 4px;
    box-shadow: var(--shadow);
    overflow: hidden;
    border: 1px solid var(--border);
  }

  /* ── Header ── */
  .inv-header {
    background: var(--accent);
    padding: 28px 36px;
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 20px;
    align-items: start;
  }
  .brand-name { font-family: 'Playfair Display', serif; font-size: 26px; color: white; letter-spacing: 0.5px; }
  .brand-sub { font-size: 11px; color: rgba(255,255,255,0.55); letter-spacing: 2px; text-transform: uppercase; margin-top: 2px; }
  .brand-contact { font-size: 11px; color: rgba(255,255,255,0.6); margin-top: 8px; line-height: 1.8; }

  .doc-meta { text-align: right; }
  .doc-title { font-family: 'Playfair Display', serif; font-size: 13px; color: rgba(255,255,255,0.5); text-transform: uppercase; letter-spacing: 3px; }
  .doc-tin { font-family: 'DM Mono', monospace; font-size: 22px; color: white; font-weight: 500; letter-spacing: 2px; }
  .status-chip { display: inline-block; margin-top: 8px; padding: 3px 12px; border-radius: 20px; font-size: 11px; font-weight: 600; letter-spacing: 1px; text-transform: uppercase; }
  .chip-booked { background: rgba(26,107,74,0.3); color: #7fffc4; border: 1px solid rgba(127,255,196,0.3); }
  .chip-cancelled { background: rgba(139,26,26,0.4); color: #ffb3b3; border: 1px solid rgba(255,179,179,0.3); }

  /* ── Journey strip ── */
  .journey-strip {
    background: var(--paper);
    border-bottom: 1px solid var(--border);
    padding: 24px 36px;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: 16px;
  }
  .city-label { font-size: 10px; color: var(--ink3); text-transform: uppercase; letter-spacing: 2px; margin-bottom: 4px; }
  .city-name { font-family: 'Playfair Display', serif; font-size: 22px; color: var(--ink); }
  .city-time { font-family: 'DM Mono', monospace; font-size: 30px; color: var(--accent); font-weight: 500; margin-top: 2px; }
  .city-date { font-size: 11px; color: var(--ink3); margin-top: 4px; }

  .journey-mid { text-align: center; }
  .dur-pill {
    background: var(--white);
    border: 1px solid var(--border);
    border-radius: 20px;
    padding: 5px 14px;
    font-size: 11px;
    color: var(--ink2);
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    white-space: nowrap;
  }
  .route-line {
    width: 100%;
    height: 1px;
    background: linear-gradient(90deg, transparent, var(--border), transparent);
    margin: 8px 0;
    position: relative;
  }
  .route-line::before, .route-line::after {
    content: '';
    position: absolute;
    top: -3px;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: var(--accent2);
  }
  .route-line::before { left: 0; }
  .route-line::after { right: 0; }

  .dest { text-align: right; }

  /* ── Operator bar ── */
  .operator-bar {
    background: var(--white);
    border-bottom: 1px solid var(--border);
    padding: 14px 36px;
    display: flex;
    gap: 32px;
    flex-wrap: wrap;
    align-items: center;
  }
  .op-item { display: flex; flex-direction: column; }
  .op-label { font-size: 9px; color: var(--ink3); text-transform: uppercase; letter-spacing: 1.5px; margin-bottom: 2px; }
  .op-value { font-size: 13px; font-weight: 500; color: var(--ink); }
  .op-value.mono { font-family: 'DM Mono', monospace; font-size: 12px; }
  .badge-small {
    display: inline-flex; align-items: center; gap: 4px;
    background: #e8f5ee; color: var(--green);
    border: 1px solid #b3dfc7;
    padding: 2px 8px; border-radius: 12px;
    font-size: 10px; font-weight: 600;
  }

  /* ── Body ── */
  .inv-body { padding: 32px 36px; display: grid; grid-template-columns: 1fr 340px; gap: 32px; }
  @media (max-width: 700px) { .inv-body { grid-template-columns: 1fr; } .journey-strip { grid-template-columns: 1fr; } .inv-header { grid-template-columns: 1fr; } }

  /* ── Section ── */
  .section { margin-bottom: 28px; }
  .sec-title {
    font-size: 9px;
    text-transform: uppercase;
    letter-spacing: 2.5px;
    color: var(--ink3);
    font-weight: 600;
    margin-bottom: 14px;
    padding-bottom: 8px;
    border-bottom: 1px solid var(--border);
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .sec-title svg { opacity: .5; }

  /* ── Passenger cards ── */
  .pax-card {
    border: 1px solid var(--border);
    border-radius: 4px;
    display: grid;
    grid-template-columns: 1fr auto;
    overflow: hidden;
    margin-bottom: 10px;
  }
  .pax-info { padding: 12px 16px; }
  .pax-name { font-weight: 600; font-size: 15px; color: var(--ink); }
  .pax-name.primary::after { content: 'PRIMARY'; font-size: 8px; background: var(--accent2); color: white; padding: 1px 6px; border-radius: 3px; margin-left: 8px; font-weight: 700; letter-spacing: 1px; vertical-align: middle; }
  .pax-meta { font-size: 12px; color: var(--ink3); margin-top: 3px; }
  .pax-mobile { font-size: 11px; color: var(--ink3); margin-top: 2px; font-family: 'DM Mono', monospace; }
  .pax-seat {
    background: var(--accent);
    color: white;
    width: 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-left: 1px solid rgba(255,255,255,0.1);
  }
  .seat-lbl { font-size: 8px; text-transform: uppercase; letter-spacing: 1.5px; opacity: .6; }
  .seat-num { font-family: 'Playfair Display', serif; font-size: 28px; font-weight: 700; line-height: 1; }

  .pax-fare-row {
    padding: 8px 16px;
    border-top: 1px dashed var(--border);
    display: flex;
    gap: 20px;
    font-size: 11px;
    color: var(--ink3);
    background: #fafafa;
  }
  .pax-fare-row span b { color: var(--ink); font-weight: 600; }

  /* ── Stations ── */
  .station-box {
    border: 1px solid var(--border);
    border-radius: 4px;
    padding: 14px 16px;
    margin-bottom: 10px;
    position: relative;
  }
  .station-box.boarding { border-left: 3px solid var(--accent); }
  .station-box.dropping { border-left: 3px solid var(--accent2); }
  .station-type { font-size: 9px; text-transform: uppercase; letter-spacing: 2px; font-weight: 700; margin-bottom: 6px; }
  .station-type.boarding { color: var(--accent); }
  .station-type.dropping { color: var(--accent2); }
  .station-name { font-weight: 600; font-size: 14px; color: var(--ink); }
  .station-addr { font-size: 11px; color: var(--ink3); margin-top: 3px; line-height: 1.5; }
  .station-landmark { font-size: 10px; color: var(--ink3); margin-top: 2px; font-style: italic; }
  .station-phone { font-size: 11px; color: var(--ink2); margin-top: 6px; font-family: 'DM Mono', monospace; }

  /* ── Right col ── */
  /* fare breakdown */
  .fare-table { width: 100%; border-collapse: collapse; }
  .fare-table tr td { padding: 7px 0; font-size: 13px; border-bottom: 1px solid var(--border); }
  .fare-table tr:last-child td { border-bottom: none; }
  .fare-table .label { color: var(--ink2); }
  .fare-table .val { text-align: right; font-family: 'DM Mono', monospace; font-size: 12px; color: var(--ink); }
  .fare-total-row td { padding-top: 12px; border-top: 2px solid var(--ink); font-weight: 700; font-size: 15px; }
  .fare-total-row .label { color: var(--ink); }
  .fare-total-row .val { font-family: 'Playfair Display', serif; font-size: 20px; color: var(--accent); }

  /* cancellation table */
  .cancel-table { width: 100%; border-collapse: collapse; font-size: 11px; }
  .cancel-table th { background: var(--paper); padding: 6px 10px; font-weight: 600; text-align: left; color: var(--ink2); border: 1px solid var(--border); font-size: 10px; text-transform: uppercase; letter-spacing: 1px; }
  .cancel-table td { padding: 6px 10px; border: 1px solid var(--border); color: var(--ink2); }
  .cancel-table td:last-child { text-align: right; font-weight: 600; font-family: 'DM Mono', monospace; color: var(--red); }

  /* policies */
  .policy-item { display: flex; align-items: flex-start; gap: 8px; font-size: 11px; color: var(--ink3); margin-bottom: 6px; line-height: 1.5; }
  .policy-dot { width: 4px; height: 4px; background: var(--accent2); border-radius: 50%; flex-shrink: 0; margin-top: 5px; }

  /* ── Footer ── */
  .inv-footer {
    background: var(--paper);
    border-top: 1px solid var(--border);
    padding: 16px 36px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    align-items: center;
  }
  .footer-meta { display: flex; gap: 28px; flex-wrap: wrap; }
  .footer-item { font-size: 11px; color: var(--ink3); }
  .footer-item b { color: var(--ink); font-weight: 500; display: block; font-size: 12px; }
  .footer-brand { font-size: 11px; color: var(--ink3); }
  .footer-brand strong { color: var(--ink2); }

  /* watermark for cancelled */
  .cancelled-watermark {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-30deg);
    font-family: 'Playfair Display', serif;
    font-size: 80px;
    color: rgba(139,26,26,0.08);
    font-weight: 700;
    pointer-events: none;
    z-index: 0;
    letter-spacing: 10px;
    white-space: nowrap;
  }


`;

// ── Icons (inline SVG) ────────────────────────────────────────────────────────
const IconBus = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="1" y="3" width="22" height="16" rx="2"/><path d="M1 9h22M7 19v2M17 19v2"/></svg>
);
const IconUser = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
);
const IconMap = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/><circle cx="12" cy="9" r="2.5"/></svg>
);
const IconRupee = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 3h12M6 8h12M6 8a6 6 0 0 0 0 12h4l6-12"/></svg>
);
const IconShield = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
);
const IconPrint = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>
);
const IconBack = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>
);
const IconX = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
);
const IconClock = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
);
const IconPhone = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.15 12 19.79 19.79 0 0 1 1.08 3.4 2 2 0 0 1 3.06 1.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 8.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21 16.92z"/></svg>
);
const IconInfo = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
);

// ── Main component ────────────────────────────────────────────────────────────
const BusInvoice = () => {
  const { ticketId } = useParams();
  const [ticket, setTicket] = useState(MOCK);
  const [loading, setLoading] = useState(false);
  const [isCancelling, setIsCancelling] = useState(false);
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
  const invoiceRef = useRef(null);
  const guestUserId = typeof localStorage !== "undefined" ? localStorage.getItem("guestUserId") : null;

  const handleDownloadPDF = async () => {
    setIsGeneratingPdf(true);
    try {
      const [{ default: html2canvas }, { default: jsPDF }] = await Promise.all([
        import("https://cdn.skypack.dev/html2canvas@1.4.1"),
        import("https://cdn.skypack.dev/jspdf@2.5.1"),
      ]);
      const el = invoiceRef.current;
      const canvas = await html2canvas(el, { scale: 2, useCORS: true, backgroundColor: "#ffffff" });
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
      const pdfW = pdf.internal.pageSize.getWidth();
      const pdfH = (canvas.height * pdfW) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfW, pdfH);
      pdf.save(`ticket-${ticket.tin || "invoice"}.pdf`);
    } catch (err) {
      console.error("PDF generation failed:", err);
      Swal.fire({ title: "PDF Failed", text: "Could not generate PDF. Please try again.", icon: "error" });
    } finally {
      setIsGeneratingPdf(false);
    }
  };

  useEffect(() => {
    if (!ticketId) return;
    setLoading(true);
    setTicket(null);
    axios.get(`${baseurl}getTicketDetails/${ticketId}`)
      .then(r => { if (r.data.data) setTicket(r.data.data); })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [ticketId]);

  const handleCancelTicket = async () => {
    const result = await Swal.fire({
      title: "Cancel Booking?",
      text: "This action cannot be undone. Refund will be processed per cancellation policy.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#8b1a1a",
      cancelButtonColor: "#1a4a6b",
      confirmButtonText: "Yes, cancel",
      cancelButtonText: "Keep booking",
    });
    if (!result.isConfirmed) return;
    setIsCancelling(true);
    try {
      const payload = { tin: ticket.tin, seatsToCancel: ticket.inventoryItems.map(i => i.seatName), guestUserId };
      const res = await axios.post(`${baseurl}cancelBusTicketGuest`, payload);
      if (res.data.status === "success") {
        await Swal.fire({ title: "Cancelled!", text: `Refund of ₹${res.data.refundAmount || 0} initiated.`, icon: "success" });
        window.location.reload();
      }
    } catch (err) {
      Swal.fire({ title: "Failed", text: err.response?.data?.error || "Unexpected error.", icon: "error" });
    } finally { setIsCancelling(false); }
  };

  if (loading) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'DM Sans',sans-serif", color: "#3d4f5c" }}>
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: 13, letterSpacing: 3, textTransform: "uppercase", opacity: .5 }}>Generating Invoice…</div>
      </div>
    </div>
  );

  if (!ticket) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'DM Sans',sans-serif" }}>
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: 48, marginBottom: 12, opacity: .15 }}>🎫</div>
        <div style={{ fontWeight: 600, color: "#3d4f5c" }}>Ticket Not Found</div>
        <button onClick={() => window.history.back()} style={{ marginTop: 16, padding: "8px 20px", background: "#1a4a6b", color: "white", border: "none", borderRadius: 6, cursor: "pointer" }}>Go Back</button>
      </div>
    </div>
  );

  const items = Array.isArray(ticket.inventoryItems) ? ticket.inventoryItems : [ticket.inventoryItems];
  const doj = new Date(ticket.doj);
  const durationMins = parseInt(ticket.dropTime) - parseInt(ticket.pickupTime);
  const policies = parsePolicy(ticket.cancellationPolicy);
  const totalBase = items.reduce((a, c) => a + parseFloat(c.baseFare || 0), 0);
  const totalTax = items.reduce((a, c) => a + parseFloat(c.serviceTax || 0), 0);
  const totalOpCharge = items.reduce((a, c) => a + parseFloat(c.operatorServiceCharge || 0), 0);
  const totalFare = parseFloat(ticket.amount || 0);

  const isCancelled = ticket.status === "CANCELLED";

  return (
    <>
      <style>{CSS}</style>
      <div className="inv-page" style={{marginTop: "100px"}}>
        {isCancelled && <div className="cancelled-watermark no-print">CANCELLED</div>}

        {/* Top bar */}
        <div className="top-bar no-print">
          <button className="btn btn-ghost" onClick={() => window.history.back()}><IconBack /> Back</button>
          <div style={{ display: "flex", gap: 10 }}>
            {!isCancelled && (
              <button className="btn btn-danger" onClick={handleCancelTicket} disabled={isCancelling}>
                {isCancelling ? "Cancelling…" : <><IconX /> Cancel Booking</>}
              </button>
            )}
            <button className="btn btn-primary" onClick={handleDownloadPDF} disabled={isGeneratingPdf}>
                <IconPrint /> {isGeneratingPdf ? "Generating…" : "Download PDF"}
              </button>
          </div>
        </div>

        <div className="invoice" ref={invoiceRef}>
          {/* ── Header ── */}
          <div className="inv-header">
            <div>
              <div className="brand-name">TopAirView</div>
              <div className="brand-sub">Solutions Limited</div>
              <div className="brand-contact">
                ✉ a2zyatra2012@gmail.com<br />
                ⌂ Bholagiri Road, Haridwar, UK 249401
              </div>
            </div>
            <div className="doc-meta">
              <div className="doc-title">Electronic Ticket</div>
              <div className="doc-tin">{ticket.tin}</div>
              <div>
                <span className={`status-chip ${isCancelled ? "chip-cancelled" : "chip-booked"}`}>
                  ● {ticket.status}
                </span>
              </div>
            </div>
          </div>

          {/* ── Journey Strip ── */}
          <div className="journey-strip">
            <div>
              <div className="city-label">Departure</div>
              <div className="city-name">{ticket.sourceCity}</div>
              <div className="city-time">{minsToTime(parseInt(ticket.pickupTime))}</div>
              <div className="city-date">{formatDOJ(ticket.doj)}</div>
            </div>
            <div className="journey-mid">
              <div className="dur-pill"><IconClock /> {Math.floor(durationMins / 60)}h {durationMins % 60}m</div>
              <div className="route-line"></div>
              <div style={{ fontSize: 10, color: "#7a8fa0", letterSpacing: 1 }}>DIRECT</div>
            </div>
            <div className="dest">
              <div className="city-label">Arrival</div>
              <div className="city-name">{ticket.destinationCity}</div>
              <div className="city-time">{minsToTime(parseInt(ticket.dropTime))}</div>
              <div className="city-date">{formatDOJ(ticket.doj)}</div>
            </div>
          </div>

          {/* ── Operator bar ── */}
          <div className="operator-bar">
            <div className="op-item">
              <span className="op-label">Operator</span>
              <span className="op-value">{ticket.travels}</span>
            </div>
            <div className="op-item">
              <span className="op-label">Bus Type</span>
              <span className="op-value">{ticket.busType}</span>
            </div>
            <div className="op-item">
              <span className="op-label">PNR</span>
              <span className="op-value mono">{ticket.displayPnr || ticket.pnr?.split("/")[1]}</span>
            </div>
            <div className="op-item">
              <span className="op-label">Date of Journey</span>
              <span className="op-value">{doj.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}</span>
            </div>
            <div className="op-item">
              <span className="op-label">Seats</span>
              <span className="op-value">{items.map(i => i.seatName).join(", ")}</span>
            </div>
            {ticket.MTicketEnabled === "true" && (
              <div className="op-item">
                <span className="badge-small">✓ M-Ticket</span>
              </div>
            )}
          </div>

          {/* ── Body ── */}
          <div className="inv-body">
            {/* Left column */}
            <div>
              {/* Passengers */}
              <div className="section">
                <div className="sec-title"><IconUser /> Passenger Details</div>
                {items.map((item, idx) => (
                  <div className="pax-card" key={idx}>
                    <div>
                      <div className="pax-info">
                        <div className={`pax-name ${item.passenger?.primary === "true" ? "primary" : ""}`}>
                          {item.passenger?.title} {item.passenger?.name}
                        </div>
                        <div className="pax-meta">
                          {item.passenger?.age} yrs · {item.passenger?.gender}
                        </div>
                        {item.passenger?.mobile && (
                          <div className="pax-mobile"><IconPhone style={{marginRight:4}}/>{item.passenger.mobile}</div>
                        )}
                      </div>

                    </div>
                    <div className="pax-seat">
                      <span className="seat-lbl">Seat</span>
                      <span className="seat-num">{item.seatName}</span>
                    </div>
                  </div>
                ))}
              </div>

              {/* Stations */}
              <div className="section">
                <div className="sec-title"><IconMap /> Boarding & Dropping</div>
                <div className="station-box boarding">
                  <div className="station-type boarding">▲ Boarding Point</div>
                  <div className="station-name">{ticket.pickupLocation}</div>
                  <div className="station-addr">{ticket.pickUpLocationAddress}</div>
                  {ticket.pickupLocationLandmark && <div className="station-landmark">Near: {ticket.pickupLocationLandmark}</div>}
                  {ticket.pickUpContactNo && <div className="station-phone"><IconPhone /> {ticket.pickUpContactNo}</div>}
                  <div style={{fontSize:10,color:"#7a8fa0",marginTop:6}}>
                    Pickup Time: <b style={{color:"#3d4f5c"}}>{minsToTime(parseInt(ticket.pickupTime))}</b>
                  </div>
                </div>
                <div className="station-box dropping">
                  <div className="station-type dropping">▼ Dropping Point</div>
                  <div className="station-name">{ticket.dropLocation}</div>
                  <div className="station-addr">{ticket.dropLocationAddress}</div>
                  {ticket.dropLocationLandmark && <div className="station-landmark">Near: {ticket.dropLocationLandmark}</div>}
                  <div style={{fontSize:10,color:"#7a8fa0",marginTop:6}}>
                    Drop Time: <b style={{color:"#3d4f5c"}}>{minsToTime(parseInt(ticket.dropTime))}</b>
                  </div>
                </div>
              </div>

              {/* Additional info */}
              <div className="section">
                <div className="sec-title"><IconInfo /> Additional Information</div>
                <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:8}}>
                  {[
                    ["Trip Code", ticket.tripCode],
                    ["Vaccinated Bus", ticket.vaccinatedBus === "true" ? "Yes" : "No"],
                    ["Vaccinated Staff", ticket.vaccinatedStaff === "true" ? "Yes" : "No"],
                    ["Partial Cancellation", ticket.partialCancellationAllowed === "true" ? "Allowed" : "Not Allowed"],
                    ["Service Start", ticket.serviceStartTime],
                    ["Booking Fee", `₹${ticket.bookingFee}`],
                  ].map(([k, v]) => (
                    <div key={k} style={{background:"#fafaf8", border:"1px solid #ddd8ce", borderRadius:4, padding:"8px 12px"}}>
                      <div style={{fontSize:9,color:"#7a8fa0",textTransform:"uppercase",letterSpacing:1.5,marginBottom:2}}>{k}</div>
                      <div style={{fontSize:12,fontWeight:500,color:"#0f1923"}}>{v}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Right column */}
            <div>
              {/* Fare Breakdown */}
              <div className="section">
                <div className="sec-title"><IconRupee /> Fare Breakdown</div>
                <div style={{border:"1px solid #ddd8ce", borderRadius:4, padding:"16px"}}>
                  <table className="fare-table">
                    <tbody>
                      {/* <tr>
                        <td className="label">Base Fare ({items.length} seat{items.length > 1 ? "s" : ""})</td>
                        <td className="val">₹{fmt(totalBase)}</td>
                      </tr>
                      <tr>
                        <td className="label">Service Tax (GST)</td>
                        <td className="val">₹{fmt(totalTax)}</td>
                      </tr> */}
                      {totalOpCharge > 0 && (
                        <tr>
                          <td className="label">Operator Charge</td>
                          <td className="val">₹{fmt(totalOpCharge)}</td>
                        </tr>
                      )}
                      {parseFloat(ticket.serviceCharge) > 0 && (
                        <tr>
                          <td className="label">Platform Fee</td>
                          <td className="val">₹{fmt(ticket.serviceCharge)}</td>
                        </tr>
                      )}
                      <tr className="fare-total-row">
                        <td className="label">Total Paid</td>
                        <td className="val">₹{fmt(totalFare)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>



              {/* Cancellation Policy */}
              <div className="section">
                <div className="sec-title"><IconShield /> Cancellation Policy</div>
                <table className="cancel-table">
                  <thead>
                    <tr>
                      <th>Hours Before Departure</th>
                      <th>Cancellation Fee</th>
                    </tr>
                  </thead>
                  <tbody>
                    {policies.map((p, i) => (
                      <tr key={i}>
                        <td>{p.hMin}–{p.hMax === "-1" ? "∞" : p.hMax} hrs</td>
                        <td>{p.pct}%</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {ticket.partialCancellationAllowed === "true" && (
                  <div style={{marginTop:8, fontSize:10, color:"#1a6b4a", background:"#e8f5ee", padding:"6px 10px", borderRadius:4, border:"1px solid #b3dfc7"}}>
                    ✓ Partial cancellation (individual seat) is allowed
                  </div>
                )}
              </div>

              {/* Rescheduling */}
              {ticket.reschedulingPolicy && (
                <div className="section">
                  <div className="sec-title">Rescheduling Policy</div>
                  <div style={{fontSize:11, color:"#7a8fa0", background:"#fafaf8", border:"1px solid #ddd8ce", borderRadius:4, padding:"10px 12px"}}>
                    {ticket.reschedulingPolicy.reschedulingCharge === "-1"
                      ? "Rescheduling is not available for this booking."
                      : `Rescheduling charge: ₹${ticket.reschedulingPolicy.reschedulingCharge}. Window: ${ticket.reschedulingPolicy.windowTime} hrs.`}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* ── Footer ── */}
          <div className="inv-footer">
            <div className="footer-meta">
              <div className="footer-item"><b>Vendor PNR</b>{ticket.vendorPnr}</div>
              <div className="footer-item"><b>Full PNR</b>{ticket.pnr}</div>
              <div className="footer-item"><b>Issued On</b>{formatDate(ticket.dateOfIssue)}</div>
              <div className="footer-item"><b>Cancellation Calc. As Of</b>{ticket.cancellationCalculationTimestamp}</div>
            </div>
            <div className="footer-brand">
              <strong>© 2026 TopAirView Solutions Limited</strong><br />
              This is a computer-generated invoice.
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BusInvoice;
